<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="main">
          <div (click)="closeModal()" class="close-icon">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
          <div class="text-center">
            <img id="success-icon" src="assets/image/success-icon.svg" />
          </div>
          <div class="mt-3 text-center">
            <h3>Comprovante enviado com sucesso!</h3>
            <p class="mt-3 mb-5">
              Nosso time irá analisá-lo para dar prosseguimento ao envio da
              ordem. Caso precise de informações adicionais ou tenha alguma
              dúvida sobre o processo de análise, não hesite em entrar em
              contato com o nosso suporte ao cliente.
            </p>
          </div>
          <div>
            <button
              class="btn btn-block mt-3"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              type="button"
              (click)="closeModal()"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex flex-row-reverse w-100">
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="main">
              <mat-icon
                class="mb-4"
                style="transform: scale(2.5)"
                svgIcon="success"
              ></mat-icon>
              <p
                [ngClass]="isMobile ? 'text-center' : ''"
                class="message mb-4 mt-3"
              >
                Comprovante enviado com sucesso!
              </p>
              <p class="description mb-4">
                Nosso time irá analisá-lo para dar prosseguimento ao envio da
                ordem. Caso precise de informações adicionais ou tenha alguma
                dúvida sobre o processo de análise, não hesite em entrar em
                contato com o nosso suporte ao cliente.
              </p>
              <button
                (click)="closeModal()"
                type="button"
                class="btn btn-block mt-4 w-50"
                [ngClass]="
                  companyId
                    ? 'btn-dark-primary-blue'
                    : 'btn-dark-primary-blue-pf'
                "
                type="button"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
